import { render } from "./SalesReport.vue?vue&type=template&id=2195822f"
import script from "./SalesReport.vue?vue&type=script&lang=js"
export * from "./SalesReport.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__